var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47512 3.68002C7.04614 2.30457 8.95513 2.30458 9.52615 3.68003L9.92389 4.63807C10.1577 5.20136 10.6712 5.59185 11.2666 5.65934L12.3766 5.78512C13.7782 5.94396 14.3572 7.70441 13.3335 8.69495L12.3911 9.60681C11.9768 10.0077 11.7937 10.5982 11.9066 11.1696L12.1341 12.3214C12.4221 13.7793 10.8602 14.8801 9.62742 14.088L8.88308 13.6097C8.34373 13.2632 7.65754 13.2632 7.11819 13.6097L6.37385 14.088C5.14108 14.8801 3.57918 13.7793 3.86719 12.3214L4.09471 11.1696C4.20758 10.5982 4.02451 10.0077 3.61017 9.60681L2.6678 8.69495C1.6441 7.70441 2.22303 5.94396 3.62471 5.78512L4.73463 5.65934C5.33011 5.59185 5.84354 5.20136 6.07738 4.63807L6.47512 3.68002Z",
    fill: "#DD55FC",
    fillOpacity: 0.15,
    stroke: "#DD55FC",
    strokeWidth: 0.975366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDuotone);
export default __webpack_public_path__ + "static/media/starDuotone.f870e0fae755414581013b88d176dfc2.svg";
export { ForwardRef as ReactComponent };